import { Logo } from "@/components/Logo";
import { AnchorButton } from "@/components/Buttons";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-white">
    <div className="mx-auto max-w-[1440px] px-5 py-16 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 gap-10 border-b border-white/15 pb-12 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <p className="font-display text-3xl font-medium leading-tight sm:text-5xl">
            Jedna decyzja. <br />
            Cały rok dostępu do biblioteki.
          </p>
        </div>
        <div className="lg:col-span-5 lg:text-right">
          <AnchorButton to="#abonamenty" variant="red" testId="footer-wybieram-abonament-button">
            Wybieram abonament
          </AnchorButton>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-8 pt-10 text-[13px] text-white/60 sm:grid-cols-3">
        <div>
          <Logo dark />
          <p className="mt-4 leading-relaxed">
            Luiza Wójtowicz-Waga Language Consulting
            <br />
            ul. Grzymalitów 1 C/29, 03-141 Warszawa
            <br />
            NIP: 524-105-48-62
          </p>
        </div>
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white/40">Kontakt</p>
          <a href="mailto:info@luizawojtowiczwaga.com" data-testid="footer-email-link" className="mt-3 block hover:text-white">
            info@luizawojtowiczwaga.com
          </a>
          <a href="tel:+48607275751" data-testid="footer-phone-link" className="mt-1 block hover:text-white">
            +48 607 275 751
          </a>
          <a href="https://luizawojtowiczwaga.com" target="_blank" rel="noopener noreferrer" data-testid="footer-site-link" className="mt-1 block hover:text-white">
            luizawojtowiczwaga.com
          </a>
        </div>
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white/40">Informacje</p>
          <a href="https://luizawojtowiczwaga.elms.pl/podstrona/1/regulamin.html" target="_blank" rel="noopener noreferrer" data-testid="footer-terms-link" className="mt-3 block hover:text-white">
            Regulamin sklepu
          </a>
          <a href="https://luizawojtowiczwaga.elms.pl/podstrona/2/polityka-prywatnosci.html" target="_blank" rel="noopener noreferrer" data-testid="footer-privacy-link" className="mt-1 block hover:text-white">
            Polityka prywatności
          </a>
          <p className="mt-6 text-white/35">© {new Date().getFullYear()} Luiza Wójtowicz-Waga. Wszystkie prawa zastrzeżone.</p>
        </div>
      </div>
    </div>
  </footer>
);
